import type { RosterCompResAllTimeCommitsRelatedResRelatedPagedData } from '@on3/api';
import { adjustColorForReadability } from '@on3/ui-lib/utils/accessibility/color';
import { slugify } from '@on3/ui-lib/utils/slugify';
import { TextLink } from '@public/components/UI/Link/TextLink';
import { Text } from '@public/components/UI/Typography/Text';

import styles from './FormerAthletes.module.scss';
import { FormerAthletesItem } from './FormerAthletesItem';

interface IFormerAthletesProps {
  formerAthletes?: RosterCompResAllTimeCommitsRelatedResRelatedPagedData;
}

export const FormerAthletes = ({ formerAthletes }: IFormerAthletesProps) => {
  const { relatedModel, list } = formerAthletes ?? {};
  const sport = relatedModel?.sport?.name;
  const slug = relatedModel?.organization?.urlSlug;

  const viewAllRoute = `/high-school/${slug}/${slugify(
    sport || 'football',
  )}/alumni/`;
  const viewAllFormerAthletes = list && list?.length > 5;
  const schoolPrimaryColor = adjustColorForReadability(
    relatedModel?.organization?.primaryColor || '#fe3b1f',
  );

  return (
    <section className={styles.block}>
      <h2 className={styles.heading}>Notable Alumni</h2>
      {list ? (
        <>
          <ol className={styles.list}>
            {list.slice(0, 5).map((item, index) => {
              return (
                <FormerAthletesItem
                  athlete={item}
                  index={index}
                  key={item.hsPsoKey}
                  relatedModel={relatedModel}
                />
              );
            })}
          </ol>
          {viewAllFormerAthletes && (
            <div>
              <TextLink
                className={styles.btnViewAll}
                href={viewAllRoute}
                style={{ color: schoolPrimaryColor }}
              >
                View All Top {sport} Alumni
              </TextLink>
            </div>
          )}
        </>
      ) : (
        <Text>There are no notable alumni from this school.</Text>
      )}
    </section>
  );
};
